import { useState } from 'react'

import { faDownload } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, Container, Paper, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { DataGridPro } from '@mui/x-data-grid-pro'
import { useSelector } from 'react-redux'

import LoadingBubbles from 'components/LoadingBubbles'
import { Principle } from 'routes/document-batches/DailyBatches/Principle'
import { useDocumentDelegateName } from 'store/college/hooks'
import { selectUserScid } from 'store/user'

import getColumns from './columns'
import { bulkDownloadFiles, useGetStudentInquiresFiles } from './getFiles'

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
  },
  link: {
    cursor: 'pointer',
  },
  delegateBox: {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      marginRight: theme.spacing(1),
    },
  },
}))
const Files = () => {
  const classes = useStyles()
  const scid = useSelector(selectUserScid)
  const { loading, files } = useGetStudentInquiresFiles({ scid })
  const [selectedFileIds, setSelectedFileIds] = useState<string[]>([])
  const [pageSize, setPageSize] = useState<number>(25)

  const documentDelegateName = useDocumentDelegateName()

  if (loading) {
    return (
      <Container maxWidth="xs">
        <LoadingBubbles />
      </Container>
    )
  }
  return (
    <Container
      maxWidth="lg"
      className={classes.root}
    >
      <Box>
        {documentDelegateName && (
          <Box
            my={2}
            className={classes.delegateBox}
          >
            <Principle />
            <Typography>
              <strong>{documentDelegateName}</strong> is currently receiving your handraisers files.
            </Typography>
          </Box>
        )}
      </Box>
      <Paper elevation={0}>
        <Box
          p={3}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box>
            <Typography>Student Handraisers</Typography>
            <Typography
              variant="body2"
              color="textSecondary"
            >
              New opt-in interest data delivered nightly via CSV
            </Typography>
          </Box>
          <Button
            variant="contained"
            color="primary"
            startIcon={<FontAwesomeIcon icon={faDownload} />}
            disabled={selectedFileIds.length === 0}
            onClick={() => {
              bulkDownloadFiles({ scid, fileIds: selectedFileIds })
            }}
          >
            Download
          </Button>
        </Box>
        <DataGridPro
          autoHeight
          disableColumnReorder
          columns={getColumns({ scid, styles: classes })}
          rows={files}
          disableColumnFilter
          disableColumnMenu
          disableSelectionOnClick
          checkboxSelection
          onSelectionModelChange={(newSelection) => {
            setSelectedFileIds(newSelection as string[])
          }}
          selectionModel={selectedFileIds}
          initialState={{
            sorting: {
              sortModel: [{ field: 'createdAt', sort: 'desc' }],
            },
          }}
          pagination
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[25, 50, 100]}
        />
      </Paper>
    </Container>
  )
}

export default Files
